// ── Global (org-level / reference data) ─────────────────────────────
import AppReducer from 'reduxStore/app/slice';
import AuthReducers from 'reduxStore/auth/slice';
import OrganisationReducers from 'reduxStore/organisations/slice';
import sitesReducers from 'reduxStore/sites/slice';
import FloorsReducers from 'reduxStore/floors/slice';
import CategoriesReducers from 'reduxStore/categories/slice';
import DefaultCategoriesReducers from 'reduxStore/defaultCategories/slice';
import SettingsReducers from 'reduxStore/settings/slice';
import DefaultSettingsReducers from 'reduxStore/defaultSettings/slice';
import TypesReducers from 'reduxStore/types/slice';
import RolesReducers from 'reduxStore/roles/slice';
import MapsReducers from 'reduxStore/maps/slice';
import RemoteConfigReducers from 'reduxStore/fbRemoteConfig/slice';
import OnboardingReducers from 'reduxStore/onboarding/slice';
import BillingReducers from 'reduxStore/billing/slice';
import SiteTrialStaffReducers from 'reduxStore/siteTrialStaff/slice';
import DemoReducers from 'reduxStore/demo/slice';
import ApprovalsReducers from 'reduxStore/approvals/slice';
import FeatureFlagsReducers from 'reduxStore/featureFlags/slice';
import NotificationsReducers from 'reduxStore/notifications/slice';
import AlertRulesReducers from 'reduxStore/alertRules/slice';
import AlertInstancesReducers from 'reduxStore/alertInstances/slice';
import GlobalAlertRulesReducers from 'reduxStore/globalAlertRules/slice';
import SlackReducers from 'reduxStore/slack/slice';
import AuditLogsReducers from 'reduxStore/auditLogs/slice';
import ReportsReducers from 'reduxStore/reports/slice';

// ── Shared: Access + Lockers (scoped by siteID) ────────────────────
import PeopleReducers from 'reduxStore/people/slice';
import DevicesReducers from 'reduxStore/devices/slice';
import CamerasReducers from 'reduxStore/cameras/slice';

// ── Access product (scoped by siteID) ──────────────────────────────
import TeamsReducers from 'reduxStore/teams/slice';
import AssetGroupReducers from 'reduxStore/assetGroups/slice';
import CredentialsReducers from 'reduxStore/credentials/slice';
import accessReducers from 'reduxStore/access/slice';
import accessWindowsReducers from 'reduxStore/accessWindows/slice';
import openAccessReducers from 'reduxStore/openAccess/slice';
import accessLogsReducers from 'reduxStore/accessLogs/slice';
import InnerRangeReducers from 'reduxStore/innerRange/slice';
import InceptionReducers from 'reduxStore/inception/slice';
import M365Reducers from 'reduxStore/m365/slice';
import ControlReducers from 'reduxStore/control/slice';
import TTLockReducers from 'reduxStore/ttlock/slice';
import GatewaysReducers from 'reduxStore/gateways/slice';
import partnerReducers from 'reduxStore/partner/slice';
import partnerAdminReducers from 'reduxStore/partnerAdmin/slice';

// ── Lockers only ────────────────────────────────────────────────────
import bookingReducers from 'reduxStore/bookings/slice';
import bookableResourcesReducers from 'reduxStore/bookableResources/slice';
import dayPassesReducers from 'reduxStore/dayPasses/slice';
import visitsReducers from 'reduxStore/visits/slice';
import roomStaysReducers from 'reduxStore/roomStays/slice';
import cardStockReducers from 'reduxStore/cardStock/slice';
import maintenanceReducers from 'reduxStore/maintenance/slice';
import InventoryReducers from 'reduxStore/inventory/slice';

const reducers = {
	// ── Global ──────────────────────────────────────────────────────
	App: AppReducer,
	Auth: AuthReducers,
	Organisations: OrganisationReducers,
	Sites: sitesReducers,
	Floors: FloorsReducers,
	Categories: CategoriesReducers,
	DefaultCategories: DefaultCategoriesReducers,
	Settings: SettingsReducers,
	DefaultSettings: DefaultSettingsReducers,
	Types: TypesReducers,
	Roles: RolesReducers,
	Maps: MapsReducers,
	FbRemoteConfig: RemoteConfigReducers,
	Onboarding: OnboardingReducers,
	Billing: BillingReducers,
	SiteTrialStaff: SiteTrialStaffReducers,
	Demo: DemoReducers,
	Approvals: ApprovalsReducers,
	FeatureFlags: FeatureFlagsReducers,
	Notifications: NotificationsReducers,
	AlertRules: AlertRulesReducers,
	AlertInstances: AlertInstancesReducers,
	GlobalAlertRules: GlobalAlertRulesReducers,
	Slack: SlackReducers,
	AuditLogs: AuditLogsReducers,
	Reports: ReportsReducers,

	// ── Shared: Access + Lockers ────────────────────────────────────
	People: PeopleReducers,
	Devices: DevicesReducers,
	Cameras: CamerasReducers,

	// ── Access product ──────────────────────────────────────────────
	Teams: TeamsReducers,
	AssetGroups: AssetGroupReducers,
	Credentials: CredentialsReducers,
	Access: accessReducers,
	AccessWindows: accessWindowsReducers,
	OpenAccess: openAccessReducers,
	AccessLogs: accessLogsReducers,
	InnerRange: InnerRangeReducers,
	Inception: InceptionReducers,
	M365: M365Reducers,
	Control: ControlReducers,
	TTLock: TTLockReducers,
	Gateways: GatewaysReducers,
	Partner: partnerReducers,
	PartnerAdmin: partnerAdminReducers,

	// ── Lockers only ────────────────────────────────────────────────
	Bookings: bookingReducers,
	BookableResources: bookableResourcesReducers,
	DayPasses: dayPassesReducers,
	Visits: visitsReducers,
	// Floating room cards (credentials.roomStays, dark).
	RoomStays: roomStaysReducers,
	// Room cards setup, Card Stock tab (credentials.roomStays, dark).
	CardStock: cardStockReducers,
	Maintenance: maintenanceReducers,
	Inventory: InventoryReducers
};

export default reducers;
